export default __webpack_public_path__ + "static/media/slowBackground.490ed3d3.mp3";